import { MANIFESTO } from "../lib/content";
import { Reveal, MaskText, Line } from "../components/Motion";

export const Manifesto = () => (
  <section data-testid="manifesto" className="bg-paper py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end mb-16 md:mb-24">
        <div className="md:col-span-8">
          <Reveal><p className="text-sand-deep text-[11px] uppercase tracking-[0.3em] mb-6">The approach</p></Reveal>
          <MaskText
            as="h2"
            className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[0.95] text-ink"
            lines={["Not posed.", "Simply present."]}
          />
        </div>
        <div className="md:col-span-4">
          <Reveal delay={0.15}>
            <p className="text-ink-soft text-base md:text-lg leading-relaxed">
              I photograph weddings the way they actually feel — warm, honest and
              a little bit spontaneous. Here's what that means for your day.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.no} delay={i * 0.1} className="bg-paper">
            <div className="p-8 md:p-12 h-full flex flex-col">
              <span className="font-serif text-2xl text-sand-deep">{m.no}</span>
              <Line className="my-6" delay={i * 0.1 + 0.2} />
              <h3 className="font-serif text-2xl md:text-3xl text-ink mb-4 leading-tight">{m.title}</h3>
              <p className="text-ink-soft leading-relaxed">{m.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
